import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthStore } from '../../store/auth.store';
import { NetworkService } from '../../shared/services/network.service';

/**
 * Evita renderizar login cuando la sesión sigue válida; redirige a Inicio o Ruta del día.
 * Con snapshot de campo y sin red entra a Ruta del día aunque el JWT esté vencido.
 */
@Injectable({
  providedIn: 'root'
})
export class YaAutenticadoGuard implements CanActivate {
  private readonly authStore = inject(AuthStore);
  private readonly networkService = inject(NetworkService);
  private readonly router = inject(Router);

  canActivate(): boolean {
    const online = this.networkService.isOnline();
    if (this.authStore.debeEntrarRutaDelDiaSinRed(online)) {
      void this.router.navigateByUrl('/ruta-del-dia', { replaceUrl: true });
      return false;
    }

    if (!this.authStore.sesionValida()) {
      return true;
    }

    if (online) {
      void this.router.navigateByUrl('/inicio', { replaceUrl: true });
      return false;
    }

    // Offline con JWT válido pero sin snapshot usable: permitir ver login (no bloquear sin redirect).
    return true;
  }
}
